const setWebinarFields = (form, id, time) => {
  form.querySelector('input[name="webinarId"]').value = id;
  form.querySelector('input[name="webinarTime"]').value = time;
};

const setWebinarTimeAsNow = (form) => {
  form.querySelector(
    'input[name="webinarTime"]'
  ).value = new Date().toISOString();
};

const setDateSelectionEvent = (form) => {
  const select = form.querySelector('select');
  const submitBtn = form.querySelector('button[type="submit"]');
  if (select) {
    select.addEventListener('change', () => {
      const selections = event.target.value.split('|');
      setWebinarFields(form, selections[0], selections[1]);
    });
  } else if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      setWebinarTimeAsNow(form);
    });
  }
};

const disableButtonOnSubmit = (form) => {
  const button = form.querySelector('[type="submit"]');
  form.addEventListener('submit', () => button.setAttribute('disabled', true));
};

const initializeStealthSeminarForms = () => {
  [...document.querySelectorAll('.StealthSeminarForm')].forEach((form) => {
    setDateSelectionEvent(form);
    disableButtonOnSubmit(form);
  });
};

initializeStealthSeminarForms();
